export default __webpack_public_path__ + "eccfc345a272ec5c30cb0013d33d4f8d.svg";